export const DEFAULT_POSTGRAD_CONTRACT_DURATION = 12;
export const DEFAULT_INSTALLMENTS_MONTHS_LIMIT = 12;
